'use strict';

import { get, isEmpty} from 'lodash';
import moment from 'moment';
import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import IconButton from 'material-ui/IconButton';
import {lookup, getLookupValue} from '../../../../../../redux/helpers/staticData';

import StatusDropDown from '../../../../../../common/components/StatusDropDown';
import EditIcon from '../../../../../../common/svgs/EditIcon';
import DocumentIcon from '../../../../../../common/svgs/DocumentIcon';
import AddContact from '../../../../../../common/svgs/AddContact';
import prettyPhone from '../../../../../../lib/prettyPhone';
import { formatCompanyUrlForHyperlink, extractCompanyUrlFromEmail } from '../../../../../../lib/formatCompanyUrl';
import * as companyApi from '../../../../../../redux/actionCreators/async/companies';
import * as companyStore from '../../../../../../redux/actionCreators/sync/companies';
import EditCompanyDetails from '../EditDetails';
import CompanyDocuments from '../Documents';
import NewCompanyContact from '../NewContact';
import TransferItemOwnershipDialogIcon from '../../../../../../common/svgs/TransferItemOwnershipDialogIcon';
import ReactTooltip from 'react-tooltip';
import ContactTransferOwnership from '../../ContactTransferOwnership';

const MODES = {
  empty: 0,
  view: 1,
  edit: 2,
  contact: 3
};

const dropDownCustomization = {
  labelStyle: {
    color: '#ffffff',
    paddingLeft: '10px',
  }
};

@connect((store) => {
  const company = store.admin.company;
  const companyStatus = store.staticData.companyStatus;
  // users "entire" roles, not just names
  const userRoles = store.staticData.employeeRoles.filter(role => store.user.roles.includes(role.name));
  // roles allowed to transfer
  const requiredRoles = store.staticData.employeeRoles.filter(role => role.hardcodelink === 'SYSTEM_ADMINISTRATOR' || role.hardcodelink === 'EMPLOYEE');
  // ensure that user has all the required roles to transfer
  const transferButtonAllowed = requiredRoles.every(role => userRoles.includes(role));
  return {
    staticData: store.staticData,
    company,
    companyStatus,
    contacts: store.companyContacts,
    currentUser : store.user,
    showTransferOwnershipButton: transferButtonAllowed
  };
})
export default class CompanyDetails extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    company: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    companyStatus: PropTypes.object.isRequired,
    contacts: PropTypes.array.isRequired,
    currentUser: PropTypes.object,
    showTransferOwnershipButton: PropTypes.bool
  }

  constructor(props, context) {
    super(props, context);
    const mode = (props.company) ? MODES.view : MODES.empty;
    const initialState = {
      mode,
      relationshipManagers: this.props.staticData.relationshipManagers,
      showDocuments: false,
      status: this.props.company.companyStatus,
      showContactTransferOwnershipModal: false
    };
    this.getCompanyUrl = ::this.getCompanyUrl;
    this.state = initialState;
  }

  getCompanyUrl() {
    if (this.props.company.website) {
      return formatCompanyUrlForHyperlink(this.props.company.website);
    } else {
      if (isEmpty(this.props.contacts)) {
        return '';
      } else {
        const contactEmail = this.props.contacts[0].user.email;
        return extractCompanyUrlFromEmail(contactEmail);
      }
    }
  }

  handleContactTransferOwnership = () => this.toggleContactTransferOwnershipModal();

  handleEdit = () => this.setState(...this.state, { mode: MODES.edit });

  handleNewContact = () => this.setState(...this.state, { mode: MODES.contact});

  handleClose = () => this.switchModes();

  showDocuments = () => {
    this.setState({showDocuments: true});
  }

  closeDocuments = () => {
    this.setState({showDocuments: false});
  }

  handleChange = (event, value) => {

    const payload = {
      companyStatus: value,
      id: this.props.company.id
    };

    const updateCompany = (data) => this.props.dispatch(companyApi.updateCompanyStatus(data.id, data.companyStatus));
    const updateCompanyStore = (data) => this.props.dispatch(companyStore.updateCompany(data));

    updateCompany(payload)
        .then(updateCompanyStore);

    this.setState({status: value});
  }

  toggleContactTransferOwnershipModal = () => {
    this.setState({...this.state, showContactTransferOwnershipModal: !this.state.showContactTransferOwnershipModal });
    ReactTooltip.rebuild();
  };

  switchModes(mode = MODES.view) {
    this.setState(...this.state, { mode });
  }

  renderView() {

    const staticData = this.props.staticData;
    const relationshipManager = this.state.relationshipManagers.find((employee) => employee.employeeId === this.props.company.relationshipManagerId);
    const sanitize = (val) => val || '';
    const expand = (type, val) => sanitize(lookup(staticData, type, val));
    let {
      address,
      address2,
      city,
      state,
      zip,
      website
    } = this.props.company;
    state = (state) ? expand('stateList', {id: state}) : null;
    const currentStatus = getLookupValue(staticData, 'companyStatus', {id: this.state.status});

    const companyHyperlink = this.getCompanyUrl();

    return (
      <div className='view-contact-card company-card'>
        <div className='cols contact-col1'>
          <h1>{`${this.props.company.name}`}</h1>
          <div>Relationship Manager: {get(relationshipManager, 'firstName')}  {get(relationshipManager, 'lastName')}
          </div>
          <div>Company Website: <a href={`http://${companyHyperlink}`}>{website || companyHyperlink}</a>
          </div>
        </div>
        <div className='cols contact-col2'>
          <div>Time Zone: {expand('timezoneList', {id: this.props.company.timezone})}</div>
          <div>Main: {prettyPhone(this.props.company.phoneNumber)}</div>
        </div>

        <div className='cols contact-col2'>
        {
            !!(address || address2)
            &&
            <div>
            {
              `${sanitize(address)}${(address2 ? ` ${address2}` : '')}`
            }
            </div>
        }
        {
            !!(city || state)
            &&
            <div>
            {
              `${sanitize(city)}, ${sanitize(state)}, ${sanitize(zip)}`
            }
            </div>
        }
        </div>

        <div className='cols contact-col2'>
          <div>Entered: {this.props.company.dateCreated ? moment(this.props.company.dateCreated).format('L') : sanitize(this.props.company.dateCreated)}</div>
          <div>Updated: {this.props.company.dateModified ? moment(this.props.company.dateModified).format('L') : sanitize(this.props.company.dateModified)}</div>
        </div>

        <div className='cols contact-col3'>

          <StatusDropDown
              data-id='Status Dropdown'
              className='contact-status-dropdown'
              smallDisplay
              status={currentStatus}
              value={this.state.status}
              menuItems={staticData.companyStatus}
              {...dropDownCustomization}
              onChange={this.handleChange}
          />

          <ul className='buttons'>
            {
              this.props.showTransferOwnershipButton
              &&
              <li>
                <IconButton data-id='Transfer Icon' tooltip='Transfer Contacts' tooltipPosition='bottom-center' onClick={this.handleContactTransferOwnership}>
                  <TransferItemOwnershipDialogIcon onClick={this.handleContactTransferOwnership} />
                </IconButton>
              </li>
            }            <li>
              <IconButton data-id='Edit' tooltip='Edit' tooltipPosition='bottom-center' onClick={this.handleEdit}>
                <EditIcon />
              </IconButton>
            </li>
            <li>
              <IconButton data-id='Documents' tooltip='Documents' tooltipPosition='bottom-center' onClick={this.showDocuments}>
                <DocumentIcon />
              </IconButton>
            </li>
            <li>
              <IconButton data-id='Contacts' tooltip='Add Contact' tooltipPosition='bottom-center' onClick={this.handleNewContact}>
                <AddContact
                  width={32}
                  height={30}
                  viewBox='0 0 33 31'
                  border />
              </IconButton>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  renderEdit() {
    return (
      <EditCompanyDetails
        company={this.props.company}
        currentUser={this.props.currentUser}
        relationshipManagers={this.state.relationshipManagers}
        website={this.getCompanyUrl()}
        timezoneList={this.props.staticData.timezoneList}
        stateList={this.props.staticData.stateList}
        dispatch={this.props.dispatch}
        onClose={this.handleClose}
      />
    );
  }

  renderAddContact() {
    return (
      <NewCompanyContact
        dispatch={this.props.dispatch}
        company={this.props.company}
        contacts={this.props.contacts}
        staticData={this.props.staticData}
        onClose={this.handleClose}
      />
    );
  }

  render() {
    return (
      <div className='company-worksheeet-details'>
      { this.state.mode === MODES.view && this.renderView() }
      { this.state.mode === MODES.edit && this.renderEdit() }
      { this.state.mode === MODES.contact && this.renderAddContact() }
      { this.state.showDocuments &&  <CompanyDocuments closeDocuments={this.closeDocuments} /> }
      {
        this.props.showTransferOwnershipButton
        && this.state.showContactTransferOwnershipModal
        &&
        <ContactTransferOwnership
          company={this.props.company}
          contacts={this.props.contacts}
          dispatch={this.props.dispatch}
          onClose={this.toggleContactTransferOwnershipModal}
          staticData={this.props.staticData}
        />
      }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/Header/Details/index.js